import type { RefType } from '../types';

const baseCopy = [
    {
        title: '멤버십',
        content: [
            {
                subtitle: '에코 포인트 제도란 무엇인가요?',
                text: '에코 포인트 제도는 에코플로우 공식 홈페이지[kr.ecoflow.com(Amazon, eBay, Walmart 등을 비롯한 다른 제3자 또는 소매업체 제외)]에서 포인트를 적립할 수 있는 프로그램입니다. 해당 포인트로 제품 구매 시 할인을 받을 수 있습니다.',
            },
            {
                subtitle: '에코 포인트 제도에 참여할 수 있는 대상은 누구인가요?',
                text: '에코플로우 공식 홈페이지 회원이면 누구나 참여가능합니다.',
            },
            {
                subtitle: '에코 포인트 제도에 참여하려면 어떻게 해야 하나요?',
                text: '에코플로우 공식 홈페이지 계정만 있다면 참여가능합니다.\n to your existing account.\n공식 홈페이지 계정이 없다면 지금 에코플로우 공식 홈페이지 회원가입을 권장드립니다. <a href="https://kr.ecoflow.com/pages/rewards-guide">회원가입 가이드</a>를 참고하십시오.',
            },
            {
                subtitle: '따로 구독비가 있나요?',
                text: '에코 포인트 제도는 별도의 구독료가 발생하지 않습니다.',
            },
            {
                subtitle: '내 보상, 혜택 및 포인트에 현금 가치가 있나요?',
                text: '에코 포인트 적립을 통해 얻은 포인트는 현금 가치가 없으며 다른 사람에게 양도할 수 없습니다.',
            },
            {
                subtitle: '두 개의 에코플로우 계정을 가지고 있는데 이를 하나로 병합할 수 있나요?',
                text: '회원마다 다른 계정에 적립된 포인트는 제품 구매 및 기타 사유를 위해 합산되지 않습니다.',
            },
            {
                subtitle: '사용 가능한 포인트는 어디에서 확인할 수 있나요?',
                text: '에코 포인트 잔액을 확인하려면 단계별 가이드를 참조하십시오.',
            },
        ],
    },
    {
        title: '포인트 적립',
        content: [
            {
                subtitle: '포인트는 어디서 적립할 수 있나요?',
                text: '모든 회원은 에코플로우 공식 홈페이지(kr.ecoflow.com) 및 에코플로우 앱에서 포인트를 적립할 수 있습니다.',
            },
            {
                subtitle: '포인트는 구매 후 언제 적립 되나요?',
                text: '포인트는 일반적으로 24시간 이내에 적립됩니다. kr.ecoflow.com에서 구매하는 경우 주문이 배송될 때까지 포인트가 계정에 보류 상태로 적립됩니다. 보류 중인 포인트는 사용할 수 없습니다.',
            },
            {
                subtitle: '포인트가 제대로 적립되지 않은 경우에는 어떻게 처리해야 하나요?',
                text: '멤버십 계정과 관련하여 문의가 있는 경우 고객센터로 문의하십시오.',
            },
            {
                subtitle: '포인트가 만료될 수 있나요?',
                text: '에코 포인트 제도가 공식적으로 시작(2022/11/04)되기 전에 적립된 포인트는 1년 후에 만료됩니다. 프로그램 정식 시작일 이후 적립된 포인트는 적립일로부터 1년 후에 만료됩니다. 만료된 포인트는 계정에서 자동으로 차감됩니다.',
            },
            {
                subtitle: '에코 포인트 제도가 출시되기 전에 이루어진 이전 거래에 대해서도 포인트를 적립할 수 있나요?',
                text: '에코 포인트 제도 정식 시작일(2022/11/04) 전에 이루어진 주문에 대한 포인트도 계정에 추가됩니다. 해당 포인트는 1년 후에 만료됩니다. 비회원 구매는 포인트 적립 대상에 포함되지 않습니다.',
            },
            {
                subtitle: '포인트는 어떻게 적립하나요?',
                text: '다음과 같은 경우에 에코 포인트를 받을 수 있습니다.\n1. 회원가입 - 신규회원 포인트 적립은 한 번만 받을 수 있습니다.\n2. 프로필 등록 - 프로필, 인물 사진, 주소를 처음 등록한 경우 포인트가 지급됩니다. 정보를 반복적으로 수정하는 경우에는 포인트를 받을 수 없습니다.\n3. 모든 구매 시 마다 - 구매한 제품의 배송이 시작되면 포인트가 적립됩니다.\n4. 제품 정보 등록 - 사용중인 제품의 정보 등록을 완료할 때마다 포인트가 적립됩니다. 등록 시 SN 코드를 잘못 입력하면 포인트를 받을 수 없습니다.',
            },
            {
                subtitle: '세금이나 배송료를 포인트로 보상받을 수 있나요?',
                text: '포인트 계산에는 회원이 지불한 모든 세금이 제외됩니다.',
            },
            {
                subtitle: '할인이나 상품권을 포인트로 적립할 수 있나요?',
                text: '제품 또는 서비스와 관련하여 제공되는 할인 또는 기타 크레딧에는 포인트가 적립되지 않습니다.',
            },
            {
                subtitle: '제품을 반품하거나 주문이 취소되면 내 포인트는 어떻게 되나요?',
                text: '제품이 반품되거나 주문이 취소되면 해당 구매에서 받은 포인트가 취소되거나 차감됩니다. 가격 조정으로 인한 부분 환불에 대해서는 포인트가 차감됩니다.',
            },
        ],
    },
    {
        title: 'EcoCredits 사용',
        content: [
            {
                subtitle: 'EcoCredits를 사용해 제품을 구매하려면 어떻게 해야 하나요?',
                text: 'EcoCredits 계정에 로그인한 후 “EcoCredits 보상 사용” 섹션으로 이동하세요. 제품을 선택하고 “지금 사용”을 클릭합니다. 그런 다음 배송 양식을 입력하고 제출합니다.',
            },
            {
                subtitle: '보상 구매 제품을 추적하려면 어떻게 해야 하나요?',
                text: '1. “내 보상” 섹션에서 보상 구매 제품의 주문 번호를 확인합니다. 주문 번호를 클릭하고 "내 계정" 페이지로 이동해 주문 배송 상태를 추적합니다. \n2. 보상 구매 후 주문 확인 이메일을 받게 됩니다. 보상 구매 제품이 배송되면 추적 번호가 담긴 배송 알림 이메일이 발송됩니다.\n3. 웹사이트 <a href="https://kr.ecoflow.com/pages/track-order">https://kr.ecoflow.com/pages/track-order</a>에서 주문 번호 또는 추적 번호를 입력하면 자세한 정보를 확인할 수 있습니다.',
            },
            {
                subtitle: '보상 구매 제품의 배송비를 결제해야 하나요?',
                text: '보상 구매 제품은 대부분 무료로 배송됩니다. 특정 제품의 경우 배송비를 결제해야 할 수 있습니다.',
            },
            {
                subtitle: '보상 구매 제품의 취소, 환불 또는 교환이 가능한가요?',
                text: '아니요. 보상 구매를 진행하기 전에 다시 한번 확인해야 합니다. 제품이 파손되어 도착한 경우, 7일 이내에 고객 서비스(<a href="mailto:support.kr@ecoflow.com">support.kr@ecoflow.com</a>)로 문의하세요.',
            },
            {
                subtitle: '에코플로우에서 구매한 제품과 보상 구매 제품이 함께 배송될 수 있나요?',
                text: '아니요. 보상 구매 제품은 별도 배송됩니다.',
            },
            {
                subtitle: '보상 구매 제품의 배송 날짜를 선택할 수 있나요?',
                text: '아니요. 보상 구매 제품은 고객의 보상 구매 확인 후 배송됩니다.',
            },
            {
                subtitle: '내가 원하는 질문이 여기 없습니다. 어디에 문의할 수 있나요?',
                text: '고객 서비스 이메일인 <a href="mailto:support.kr@ecoflow.com">support.kr@ecoflow.com</a>으로 문의하시기 바랍니다.',
            },
            {
                subtitle: '기프트 카드에 대해 문의 사항이 있습니다. 어디에 문의할 수 있나요?',
                text: '당사 고객 서비스에 에코플로우 기프트 카드 이용약관에 대해 문의하세요. 다른 기프트 카드에 대해서는 타사 고객 서비스에 문의해 주세요.',
            },
            {
                subtitle: '사용한 할인 코드나 상품권을 회수할 수 있나요?',
                text: '아니요, 사용한 보상은 두 번째 사용을 위해 회수하거나 취소할 수 없습니다.',
            },
        ],
    },
    {
        title: '플러스 멤버 및 혜택',
        content: [
            {
                subtitle: 'PLUS 회원 자격 요건 및 일반 회원과의 차이점은 무엇인가요?',
                text: 'EcoFlow는 모든 EcoFlow 고객님들께 보답하기 위해 EcoCredits 리워드 프로그램을 만들었습니다. 우리는 회원들에게 최고의 혜택, 우수한 서비스, 최신 정보를 제공합니다. 2024년 초에100만 회원을 달성하면서, 모든 회원님들께 더 많은 혜택을 제공하기 위해 EcoCredits 혜택을 업그레이드할 때가 되었습니다!\n\n회원 가입은 완전히 무료입니다. 계정에 6,000 EcoCredits이 쌓이면 바로 PLUS 회원으로 업그레이드할 수 있습니다. 일반 회원의 모든 혜택 뿐만 아니라 PLUS 회원만을 위한 독점 할인 및 서비스 혜택을 마음껏 누리세요.\n\n모든 회원을 위한 일원화된 신뢰할 수 있는 멤버십 서비스입니다. 업그레이드된 프리미엄 PLUS 혜택으로 더 많은 절약 및 안심 가능한 그린 에너지를 더 많이 경험하세요!',
            },
            {
                subtitle: 'PLUS 회원 자격이 만료될 수 있나요?',
                text: '네, 유효 기간은1년입니다. 일반 회원에서 PLUS 회원으로 업그레이드한 후1년이 지나고 계정에 EcoCredits 잔액이 6,000 미만이면 PLUS 회원 자격이 만료됩니다. 계정에 6,000 이상의 잔여 EcoCredits이 있을 시 PLUS 회원 자격을 유지할 수 있습니다.',
            },
            {
                subtitle: 'EcoCredits를 현금 공제 또는 바우처/선물로 교환하면 PLUS 회원 자격이 변경되나요?',
                text: '걱정하지 마세요! 유효 기간 내에 EcoCredits을 현금 공제 또는 바우처/선물로 교환해도 PLUS 회원 자격은 유지됩니다. 자격 유지를 위해 더 많은 EcoCredits 적립을 잊지 마세요.',
            },
            {
                subtitle: 'PLUS 회원으로서 어떤 특별 할인을 받을 수 있나요?',
                text: 'PLUS MEMBER로서 다양한 할인 바우처를 받게 됩니다:\n- 레벨 업 바우처 (첫 업그레이드 시 한정)\n- 생일 바우처\n- 월간 바우처 팩 (EcoCredits 월간 멤버십 데이 기간에 발행)\n- PLUS 단독 선물 (*참고: 누적 구매 금액이 350만원 이상인 PLUS 회원 한정, 프로그램 내 한 번만 제공됩니다.)',
            },
            {
                subtitle: 'PLUS 멤버로서 어떤 서비스 혜택을 받을 수 있나요?',
                text: 'PLUS 멤버로서 멤버십 기간 동안 다음과 같은 서비스를 누릴 수 있습니다:\n- 무조건 무료 반품 1회: 구입 후 한 달 내에 무료 반품 1회 가능합니다.\n- 보증 기간 외 서비스 요금 12% 할인: 보증 기간이 만료된 수리 서비스 요금에 특별 할인을 받으세요. EcoFlow는 실제 상황에 따라 수리 범위를 결정할 권리를 보유합니다.\n- 교환 보증 4개월 연장: 총 5개월 동안 교환 기간을 연장하여 불량품을 새제품으로 교체할 수 있습니다.\n- 빠른 교환 서비스: 제품이 수리 불가 상태인 경우 이 서비스를 이용할 수 있습니다. 고장난 제품을 보내고 배송 증명서를 제공하면, 고장난 제품을 회수하기 전이라도 새 제품을 즉시 발송합니다. 참고: 이 서비스는 4개월 추가 교환 혜택과 함께 사용할 수 없습니다.',
            },
            {
                subtitle: '이 외에도 어떠한 혜택을 누릴 수 있나요?',
                text: '새로운 EcoFlow 제품 출시 시 "신제품 체험 이벤트" (곧 출시 예정)에 참여할 수 있습니다. PLUS 멤버로서 새로운 제품을 무료로 받고 독점 사전 예약 혜택을 누리세요 (곧 출시 예정). 더 많은 혜택이 곧 제공될 예정이니 기대해 주세요!',
            },
        ],
    },
];

const accountings: { key: string; ref: RefType }[] = [
    {
        key: 'default',
        ref: baseCopy,
    },
];

const getKrCopy = (key: string) => {
    const [data] = accountings.filter((item) => item.key === key);
    const copies: RefType = data?.ref || baseCopy;
    return copies.map((item, ind) => ({ ...item, key: ind }));
};

export default getKrCopy;
